export default __webpack_public_path__ + "static/media/rgs_main_mobile.90a2191c.jpg";